import { Form, Formik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, FormGroup, Input, Modal, ModalBody, Row } from "reactstrap";
import { setCheckPasswordModalOpen } from "../../redux/actions/staff/staffAction";

export const CheckPassword = ({ handleSubmit }) => {
  const dispatch = useDispatch();
  const { checkPasswordModalOpen } = useSelector((state) => state.staff);

  const toggle = () => {
    dispatch(setCheckPasswordModalOpen(!checkPasswordModalOpen));
  };

  return (
    <Modal
      isOpen={checkPasswordModalOpen}
      toggle={toggle}
      centered={true}
      size="lg"
      className="large-pop delete-pop"
    >
      <ModalBody>
        <div className="modal-body-content">
          <Formik
            initialValues={{
              password: "",
            }}
            onSubmit={handleSubmit}
          >
            {({ errors, values, touched, setFieldValue }) => {
              return (
                <Form className="admin-details">
                  <div className="content">
                    <div className="delete-title">
                      <h2 className="">Password is Required</h2>
                    </div>
                    <div className="delete-data">
                      <h4>
                        Please fill in your password to proceed with the
                        requested changes
                      </h4>
                    </div>
                    <div className="pb-4">
                      <Row className="justify-content-center">
                        <Col md={9}>
                          <FormGroup className="custom-inputs mb-md-0">
                            <Input
                              type="password"
                              name="password"
                              id="password"
                              placeholder="Type in the password"
                              onChange={(e) =>
                                setFieldValue("password", e.target.value)
                              }
                              required
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className="action-btn-block pt-2">
                    <button
                      className={`btn btn-small btn-transparent`}
                      type="button"
                      onClick={toggle}
                    >
                      {/* {!props.disabled ? props.value : } */}
                      {"Cancel"}
                    </button>
                    <button className={`btn btn-small btn-grey`} type="submit">
                      {"Check Password"}
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </ModalBody>
    </Modal>
  );
};
